import React from "react";
import { BoxIcon } from "lucide-react";
type BookCoverProps = {
  eyebrow: string;
  title: string;
  color: string;
  deep: string;
  icon: BoxIcon;
  size?: 'hero' | 'md' | 'sm';
  className?: string;
};
const sizes = {
  hero: {
    pad: 'pl-[18%] pr-[9%] py-[10%]',
    eyebrow: 'text-[5px] sm:text-[8px] md:text-[10px]',
    title: 'text-[9px] sm:text-[14px] md:text-[19px]',
    icon: 'h-2.5 w-2.5 sm:h-4 sm:w-4 md:h-5 md:w-5',
    iconWrap: 'p-1 sm:p-2 md:p-2.5',
    brand: 'text-[4px] sm:text-[6px] md:text-[8px]',
    rings: 7
  },
  md: {
    pad: 'pl-[18%] pr-[9%] py-[10%]',
    eyebrow: 'text-[10px]',
    title: 'text-xl',
    icon: 'h-6 w-6',
    iconWrap: 'p-3',
    brand: 'text-[9px]',
    rings: 8
  },
  sm: {
    pad: 'pl-[22%] pr-[8%] py-[10%]',
    eyebrow: 'hidden',
    title: 'hidden',
    icon: 'h-5 w-5',
    iconWrap: 'p-2',
    brand: 'hidden',
    rings: 5
  }
};
export function BookCover({
  eyebrow,
  title,
  color,
  deep,
  icon: Icon,
  size = 'md',
  className = ''
}: BookCoverProps) {
  const s = sizes[size];
  return <div className={`relative aspect-[3/4] overflow-hidden rounded-[4%_8%_8%_4%/3%_6%_6%_3%] shadow-[0_18px_30px_-16px_rgba(34,48,47,0.45),0_2px_4px_rgba(34,48,47,0.08)] ${className}`} style={{
    backgroundColor: color
  }} aria-hidden="true" data-id="element-53" data-mp="2ur2om89ci9e5">
      {/* spiral binding */}
      <div className="absolute inset-y-[6%] left-[4%] flex flex-col justify-between" data-id="element-54" data-mp="2pshkhxqz35kf">
        {Array.from({
        length: s.rings
      }).map((_, i) => <span key={i} className="block h-[3px] w-[6px] rounded-full bg-ink/25 sm:h-1 sm:w-2" data-id="element-55" data-mp="2gt4a92v0ycyn" data-mpi={i} />)}
      </div>
      <div className={`flex h-full flex-col ${s.pad}`} data-id="element-56" data-mp="224zy6hqh8zou">
        <span className={`font-bold uppercase tracking-[0.14em] ${s.eyebrow}`} style={{
        color: deep
      }} data-id="element-57" data-mp="222dh9rhp57ty">
          {eyebrow}
        </span>
        <span className={`mt-[6%] font-serif leading-[1.05] text-ink ${s.title}`} data-id="element-58" data-mp="1t3joydbef3m7">{title}</span>
        <span className={`mt-auto self-start rounded-full bg-white/60 ${s.iconWrap}`} data-id="element-59" data-mp="1x5n1745w6c8j">
          <Icon className={s.icon} style={{
          color: deep
        }} strokeWidth={1.75} data-id="element-60" data-mp="3n6ae6bdqgfl" />
        </span>
        <span className={`mt-[8%] font-semibold uppercase tracking-[0.18em] text-ink/50 ${s.brand}`} data-id="element-61" data-mp="3v127cbk70giu">Sesiones Listas</span>
      </div>
    </div>;
}